import { RequestOptionsService } from "./requestOptions";
import request from "request-promise";
import { ConnectedDevice } from "@/models/ConnectedDevice";

export class ConnectedDeviceService {
  public static async UpdateConnectedDevices(deviceUdid: string, setting: ConnectedDevice) {
    const options = RequestOptionsService.postBrearerOptions(`ConnectedDevices/${deviceUdid}`, {
      ID: setting.id,
      IPAddress: setting.ipAddress,
      IsAuthorized: setting.isAuthorized,
      IsConnected: setting.isConnected,
      Mode: setting.mode,
      IsSelf: setting.mode === 1 ? true : false,
      IsRegisterAtSlave: setting.isRegisterAtSlave
    });
    const result = await request(options);
    return result;
  }

  public static async AddConnectedDevices(deviceUdid: string, setting: ConnectedDevice) {
    const options = RequestOptionsService.postBrearerOptions(`ConnectedDevices/${deviceUdid}`, {
      ID: null,
      IPAddress: setting.ipAddress,
      IsAuthorized: setting.isAuthorized,
      IsConnected: setting.isConnected,
      Mode: setting.mode,
      IsSelf: setting.mode === 1 ? true : false,
      IsRegisterAtSlave: setting.isRegisterAtSlave
    });
    const result = await request(options);
    return result;
  }
}
